(function () {
  'use strict';

  var PROVIDERS = {
    chatgpt:    { name: 'ChatGPT',    base: 'https://chatgpt.com/',             param: 'q' },
    claude:     { name: 'Claude',     base: 'https://claude.ai/new',            param: 'q' },
    perplexity: { name: 'Perplexity', base: 'https://www.perplexity.ai/search', param: 'q' },
    gemini:     { name: 'Gemini',     base: 'https://gemini.google.com/app',    param: null }
  };

  var root = document.querySelector('.ai-consult-root');
  if (!root) return;

  var fab    = root.querySelector('.ai-consult-fab');
  var panel  = root.querySelector('.ai-consult-panel');
  var closeB = root.querySelector('.ai-consult-panel__close');
  var toast  = document.querySelector('.ai-consult-toast');
  var pageType = root.getAttribute('data-page-type') || 'other';
  var prompt = root.getAttribute('data-prompt') || '';

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in params) { payload[k] = params[k]; }
      window.dataLayer.push(payload);
    } catch (e) { /* 計測の失敗で導線を止めない */ }
  }

  function buildUrl(key) {
    var p = PROVIDERS[key];
    if (!p) return null;
    if (!p.param) return p.base;
    return p.base + '?' + p.param + '=' + encodeURIComponent(prompt);
  }

  function openPanel() {
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    track('ai_consult_open', { page_type: pageType });
  }

  function closePanel() {
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
  }

  function showToast(text) {
    if (!toast) return;
    toast.textContent = text;
    toast.hidden = false;
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(function () { toast.hidden = true; }, 4000);
  }

  // 同期でコピーし、成否を即座に返す。
  // clipboard API（Promise）を await してからタブを開くとポップアップ判定に落ちる。
  // 逆にタブを先に開くとフォーカスが移り、clipboard API は
  // NotAllowedError「Document is not focused」で必ず失敗する（実測）。
  // どちらも避けるため、execCommand で同期的に済ませる。
  function copySync(text) {
    var ok = false;
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.opacity = '0';
      // iOS Safari は readonly のままだと選択範囲を取れずコピーが空になる。
      ta.contentEditable = 'true';
      ta.readOnly = false;
      document.body.appendChild(ta);
      var range = document.createRange();
      range.selectNodeContents(ta);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      ta.setSelectionRange(0, text.length);
      ok = document.execCommand('copy');
      sel.removeAllRanges();
      document.body.removeChild(ta);
    } catch (e) {
      ok = false;
    }
    // 対応ブラウザではこちらの方が確実なので、待たずに併走させる。
    if (navigator.clipboard && window.isSecureContext) {
      try { navigator.clipboard.writeText(text); } catch (e) { /* 同期側の結果を使う */ }
    }
    return ok;
  }

  // コピーに失敗したときの最後の受け皿。
  // 黙って開くと利用者は「何も起きなかった」と感じるだけなので、
  // 質問文そのものを選択できる状態で見せる。
  function showPromptFallback() {
    var box = document.querySelector('.ai-consult-fallback');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ai-consult-fallback';
      box.innerHTML =
        '<p class="ai-consult-fallback__lead">この質問文をコピーして、Geminiに貼り付けてください。</p>' +
        '<textarea class="ai-consult-fallback__text" readonly rows="5"></textarea>' +
        '<button type="button" class="ai-consult-fallback__close">閉じる</button>';
      document.body.appendChild(box);
      box.querySelector('.ai-consult-fallback__close').addEventListener('click', function () {
        box.hidden = true;
      });
    }
    var ta = box.querySelector('.ai-consult-fallback__text');
    ta.value = prompt;
    box.hidden = false;
    ta.focus();
    ta.select();
  }

  function go(key) {
    var url = buildUrl(key);
    if (!url) return;
    track('ai_consult_click', { ai_provider: key, page_type: pageType });

    // Gemini は質問文をURLに乗せられないのでクリップボード経由になる。
    // 必ず「コピー → タブを開く」の順にする。逆にすると必ずコピーが失敗する。
    var needsClipboard = !PROVIDERS[key].param;
    var copied = needsClipboard ? copySync(prompt) : false;

    window.open(url, '_blank', 'noopener,noreferrer');

    if (needsClipboard) {
      showToast(copied
        ? '質問文をコピーしました。Geminiのチャット欄に貼り付けてください。'
        : '質問文をコピーできませんでした。下の質問文を選択してコピーしてください。');
      if (!copied) showPromptFallback();
    }
    closePanel();
  }

  // 画面下部に他の固定要素（購入バー・ポップアップ・サイドバー等）が
  // 表示されている間はボタンごと隠す。セレクタを決め打ちせず実測して判定する。
  // position:sticky は商品ギャラリー等の通常レイアウトでも多用されるため対象外とし、
  // ビューポート基準で常に浮く position:fixed のみを衝突判定の対象にする。
  // Shopify のテーマプレビューバーは未公開テーマの確認中だけ下部に出る。
  // 本番では存在しないため、衝突判定から除外する。
  // el.id は使わない: <form> に <input name="id"> があると要素側が返り文字列にならない。
  function isPreviewBar(el) {
    var id = el.getAttribute('id');
    return !!id && id.indexOf('PBar') === 0;
  }

  // 画面下部に居座る固定要素（購入バー等）の上端を返す。無ければ null。
  // 自分と横方向に重ならないものは対象外。右下のLINEボタンのように
  // 反対側の角にある小物で退避すると、ボタンが出ないままになるため。
  function bottomBarTop() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var mine = root.getBoundingClientRect();
    var top = null;
    var all = document.querySelectorAll('body *');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (root.contains(el) || el === root) continue;
      if (isPreviewBar(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 60) continue;
      if (r.bottom < vh * 0.5) continue;
      // 画面外へ退避中の購入バーは transform で下へ送られており、
      // 矩形が数pxだけ画面内に残る。わずかな食い込みは障害物とみなさない。
      var visibleHeight = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visibleHeight < 24) continue;
      if (r.right < mine.left || r.left > mine.right) continue;
      if (top === null || r.top < top) top = r.top;
    }
    return top;
  }

  // 購入バーの上へ押し上げる。隠すのは最後の手段にする。
  var GAP = 10;
  var liftedPx = null;
  function applyLift(px) {
    // 同じ値を書き直すと MutationObserver が再発火して無駄に回る。
    if (liftedPx === px) return;
    liftedPx = px;
    root.style.bottom = px === null ? '' : px + 'px';
  }

  // 絶対に覆ってはいけない操作要素。
  // 購入導線とフォーム部品が対象。コレクションの商品カードのような
  // 通常のコンテンツリンクは対象外（全リンクを守るとグリッド系ページで
  // ボタンが常に消えるため。実測で確認済み）。
  var CRITICAL_SELECTOR = [
    '[name="add"]',
    '[data-js-product-add-to-cart]',
    '[data-js-atc]',
    '.shopify-payment-button',
    '[name="checkout"]',
    'a[href*="/checkout"]',
    '[data-js-cart-checkout]',
    'button[type="submit"]',
    'input[type="submit"]',
    'input',
    'select',
    'textarea'
  ].join(',');

  // ボタン自身の矩形が重要な操作要素に重なっていないか。
  // 「見た目で重なっていない」ではなく矩形の交差で判定する。
  function overlapsCriticalControl() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var mine = root.getBoundingClientRect();
    if (mine.width === 0 || mine.height === 0) return false;
    var pad = 8;
    var ctas = document.querySelectorAll(CRITICAL_SELECTOR);
    for (var i = 0; i < ctas.length; i++) {
      var el = ctas[i];
      if (root.contains(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      if (r.bottom < 0 || r.top > vh || r.right < 0 || r.left > vw) continue;
      // 画面外へ退避中のバー内のCTAは対象外。
      if (Math.min(r.bottom, vh) - Math.max(r.top, 0) < 8) continue;
      var apart = r.right < mine.left - pad || r.left > mine.right + pad ||
        r.bottom < mine.top - pad || r.top > mine.bottom + pad;
      if (!apart) return true;
    }
    return false;
  }

  // フッターが画面下部に入ったら退避する。
  // 著作権リンクや言語切替がボタンの真下に来て押せなくなるため。
  function footerInView() {
    var footer = document.querySelector('[id*="shopify-section"][class*="footer-group"], footer');
    if (!footer) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var r = footer.getBoundingClientRect();
    return r.top < vh - 40 && r.bottom > 0;
  }

  var viewSent = false;
  function syncVisibility() {
    // 初回だけ hidden を外す。以降は --off クラスで制御し、
    // 退避中も矩形を測れる状態を保つ。
    if (root.hidden) root.hidden = false;

    var blocked;
    try {
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // ドロワー・モーダル表示中は位置に関係なく消す。
      if (document.body.classList.contains('sidebar-opened') ||
          document.body.classList.contains('modal-opened')) {
        applyLift(null);
        blocked = true;
      } else {
        // 下部の固定バーがあれば、その上へ押し上げる。
        // 押し上げ幅が画面の4割を超えるようなら諦めて隠す。
        var barTop = bottomBarTop();
        var tooTall = false;
        if (barTop === null) {
          applyLift(null);
        } else {
          var lift = Math.round(vh - barTop + GAP);
          // 画面の4割を超えて押し上げるほど大きい相手は、避けきれないので隠す。
          tooTall = lift > vh * 0.4;
          applyLift(tooTall ? null : lift);
        }
        // 押し上げた後の位置で、なお購入導線に重なるなら隠す。
        blocked = tooTall || overlapsCriticalControl() || footerInView();
      }
    } catch (e) {
      // 判定できないときは購入導線を優先し、ボタンを出さない側に倒す。
      // 無言で潰すと原因が追えないため、必ず残す。
      blocked = true;
      if (window.console && console.warn) console.warn('[ai-consult] 衝突判定に失敗', e);
    }

    root.classList.toggle('ai-consult-root--off', blocked);
    if (blocked && !panel.hidden) closePanel();

    if (!blocked && !viewSent) {
      var r = fab.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.height > 0 && r.top < vh && r.bottom > 0) {
        viewSent = true;
        track('ai_consult_view', { page_type: pageType });
      }
    }
  }

  // デバウンス（毎回タイマーを引き直す方式）にはしない。
  // スライダーやカウントダウン等が高頻度でDOMを変えるページでは、
  // タイマーが延々と引き直されて判定が一度も走らない（実測で発生）。
  // 最初のイベントから必ず120ms後に1回走るスロットルにする。
  var syncScheduled = false;
  var followUpTimer = null;
  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.setTimeout(function () {
      syncScheduled = false;
      syncVisibility();
      // 購入バーは transform のトランジション（約200ms）でせり上がる。
      // 1回しか測らないと遷移途中の位置を拾い、画面外だと誤判定する。
      // 端末が遅いとレイアウト確定も遅れるため、間隔を空けて2回測り直す。
      window.clearTimeout(followUpTimer);
      followUpTimer = window.setTimeout(function () {
        syncVisibility();
        followUpTimer = window.setTimeout(syncVisibility, 800);
      }, 400);
    }, 120);
  }

  fab.addEventListener('click', function () {
    panel.hidden ? openPanel() : closePanel();
  });
  if (closeB) closeB.addEventListener('click', closePanel);

  root.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-provider]');
    if (!btn) return;
    go(btn.getAttribute('data-provider'));
  });

  document.addEventListener('click', function (ev) {
    if (!panel.hidden && !root.contains(ev.target)) closePanel();
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !panel.hidden) closePanel();
  });

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  // 購入バーがせり上がり終わった瞬間を正確に捕まえる。
  // 時間差の推測だけに頼ると、遷移途中の位置で誤判定したまま確定してしまう。
  document.addEventListener('transitionend', scheduleSync, true);
  if (typeof MutationObserver === 'function') {
    new MutationObserver(scheduleSync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
      childList: true,
      subtree: true
    });
  }
  syncVisibility();
})();
